module.exports = __webpack_public_path__ + "img/success.b79a0c8d.png";